export default __webpack_public_path__ + "static/media/tony_on.53eaccbb.png";